import '../../App.css';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { ApiContext } from "../../context/ApiContext";
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral'
import Footer from '../../components/footer/Footer'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { FaPlus } from 'react-icons/fa';
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import { HiOutlineDocumentReport } from "react-icons/hi";
import ModalCadastrarSwot from '../../components/modal/ModalCadastrarSwot';
import ModalEditarSwot from '../../components/modal/ModalEditarSwot';
import ModalExcluirSwot from '../../components/modal/ModalExcluirSwot';
import ModalRelatorioSwot from '../../components/modal/ModalRelatorioSwot';
import moment from 'moment/moment';
import { TbTrash, TbPencil } from "react-icons/tb";
import { StyleContext } from '../../context/StyleContext';
import Tabela from '../../components/Tabela';

const SwotTI = () => {

    const { ObterSwot, setLoading, EditarDemandaModal, setModalEditarDemanda, Success, Error, ExcluirDemandaModal, setModalExcluirDemanda, openModal, setOpenModal, ListaCiclos, loading, CancelarDemandaModal, ConcluirDemandaModal, setCompartilharDemandaModal, CompartilharDemandaModal, ListaSwotConsulta, SwotListaConsulta, setSwotAtualKey, Permissao, ListaAreaSwot, ListaFiltroSwot, totalRegistrosSwot, filtroSwot, totalRegistrosFiltroSwot } = useContext(ApiContext)
    const { btnCriar, h3Demanda, corTerciaria } = useContext(StyleContext)

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");

    const CriarSwot = () => {
        setOpenModal(true)
    }

    const selecionarSwot = (props) => {
        ObterSwot(props.key)
            .then(() => {
                EditarSwot(props)
            })
    }

    const EditarSwot = (props) => {
        setSwotAtualKey(props.key)
        setModalEditarDemanda(true)
    }

    const ApagarSwot = (props) => {
        setSwotAtualKey(props.key)
        setModalExcluirDemanda(true)
    }

    const VerRelatorio = (props) => {
        setSwotAtualKey(props.key)
        setCompartilharDemandaModal(true)
    }

    function carregando() {
        return new Promise(function (resolve) {
            setLoading(true)
            setTimeout(resolve, 1)
        });
    }

    function naoCarregando() {
        return new Promise(function (resolve) {
            setLoading(resolve, false)
        });
    }

    const chamarLista = useCallback(async () => {
        await carregando()
        await ListaAreaSwot()
        await ListaCiclos()
        await naoCarregando()
    })

    useEffect(() => {
        chamarLista()
    }, [])

    useEffect(() => {
        if (openModal || EditarDemandaModal || ExcluirDemandaModal || CancelarDemandaModal || ConcluirDemandaModal || CompartilharDemandaModal) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        return () => {
            document.body.style.overflow = '';
        };
    }, [openModal, EditarDemandaModal, ExcluirDemandaModal, CancelarDemandaModal, ConcluirDemandaModal, CompartilharDemandaModal]);

    useEffect(() => {
        setCompartilharDemandaModal(false)
    }, [])

    useEffect(() => {
        if (searchTerm.trim() !== "") {
            ListaFiltroSwot(searchTerm, currentPage, pageSize);
        } else {
            ListaSwotConsulta(currentPage, pageSize, true);
        }
    }, [currentPage, searchTerm]);

    const totalRegistros = searchTerm.trim() !== "" ? totalRegistrosFiltroSwot : totalRegistrosSwot;
    const totalPages = Math.max(1, Math.ceil((totalRegistros || 0) / pageSize));

    return (
        <div>

            {EditarDemandaModal &&
                <ModalEditarSwot currentPage={currentPage} swotTI={true}/>
            }
            {CompartilharDemandaModal &&
                <ModalRelatorioSwot />
            }
            {ExcluirDemandaModal &&
                <ModalExcluirSwot currentPage={currentPage} swotTI={true} />
            }
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            <Header pagina={'SWOT'}></Header>
            <MenuLateral></MenuLateral>
            <div className="container-dem">
                <div className='header-dem'>
                    {openModal &&
                        <ModalCadastrarSwot closeModal={setOpenModal} currentPage={currentPage} swotTI={true} />
                    }
                    {(!!Permissao.find(item => item.menu.descricao === "SWOT" && item.edicao === true)) && <button className='btn-dash btn-criar' style={btnCriar} onClick={() => CriarSwot()}><FaPlus style={{ marginRight: "10px" }} />Cadastrar SWOT</button>
                    }
                </div>
                {loading &&
                    <div className="loading-screen">
                        <div className="loader-container">
                            <div className="spinner"></div>
                        </div>
                    </div>
                }
                <div className='card'>
                    <h3 className='h3-demanda' style={h3Demanda}>SWOTs cadastrados</h3>
                    <Tabela
                        data={searchTerm.trim() !== "" ? filtroSwot : SwotListaConsulta}
                        columns={[
                            { label: "SWOTs", field: "descricao", width: "40%" },
                            { label: "Área", field: "area.descricao", width: "40%", render: (x) => x?.area?.descricao || "-" },
                            { label: "Ciclo", field: "cicloDemanda.descricao", width: "40%", render: (x) => x?.cicloDemanda?.descricao || "-" },
                            { label: "Data criação", field: "dataCriacao", width: "40%", render: (x) => moment(x?.dataCriacao).format("DD/MM/YYYY") || "-" },
                            { label: "Usuário", field: "usuario", width: "40%", render: (x) => x?.usuario?.nome || "-" },
                            {
                                label: "Opções",
                                width: "10%",
                                align: "center",
                                render: (x) => (
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <OverlayTrigger
                                            placement="left"
                                            overlay={<Tooltip id="button-tooltip">
                                                Editar SWOT
                                            </Tooltip>}
                                        ><button className='btn-dem' style={{ color: `${corTerciaria}` }} onClick={() => selecionarSwot(x)}><TbPencil /></button>
                                        </OverlayTrigger>
                                        <OverlayTrigger
                                            placement="left"
                                            overlay={<Tooltip id="button-tooltip">
                                                Ver relatório
                                            </Tooltip>}
                                        ><button className='btn-dem' style={{ color: `${corTerciaria}` }} onClick={() => VerRelatorio(x)}><HiOutlineDocumentReport /></button>

                                        </OverlayTrigger>
                                        {(!!Permissao.find(item => item.menu.descricao === "SWOT" && item.edicao === true)) &&
                                            <OverlayTrigger
                                                placement="left"
                                                overlay={<Tooltip id="button-tooltip">
                                                    Excluir SWOT
                                                </Tooltip>}
                                            ><button className='btn-dem' style={{ color: `${corTerciaria}` }} onClick={() => ApagarSwot(x)}><TbTrash /></button>
                                            </OverlayTrigger>
                                        }
                                    </div>
                                ),
                            },
                        ]}
                        loading={loading}
                        currentPage={currentPage}
                        totalPages={totalPages}
                        setCurrentPage={setCurrentPage}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        onSearch={(term) => {
                            setCurrentPage(1);
                            if (term.trim() !== "") {
                                ListaFiltroSwot(term, 1, 10);
                            } else {
                                ListaSwotConsulta(1, 10, true);
                            }
                        }}
                        corTerciaria={corTerciaria}
                    />
                </div>
            </div>
            <Footer></Footer>
        </div>
    );
}

export default React.memo(SwotTI);